import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_3 = { class: "flex items-start justify-between" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = { class: "bg-white rounded-lg p-4 space-y-3" }
const _hoisted_6 = { class: "grid grid-cols-2 md:grid-cols-4 gap-4" }
const _hoisted_7 = { class: "font-medium" }
const _hoisted_8 = { class: "font-medium" }
const _hoisted_9 = { class: "font-medium" }
const _hoisted_10 = { class: "font-medium" }
const _hoisted_11 = {
  key: 0,
  class: "pt-3 border-t"
}
const _hoisted_12 = { class: "flex flex-wrap gap-2" }
const _hoisted_13 = { class: "flex justify-end items-center mt-4" }
const _hoisted_14 = { class: "flex items-start justify-between" }
const _hoisted_15 = { class: "flex items-center gap-3" }
const _hoisted_16 = { class: "bg-white rounded-lg p-4" }
const _hoisted_17 = { class: "font-semibold text-gray-900 mb-3 flex items-center gap-2" }
const _hoisted_18 = { class: "p-1 bg-slate-900 rounded-full" }
const _hoisted_19 = { class: "grid grid-cols-2 md:grid-cols-3 gap-4" }
const _hoisted_20 = { class: "font-medium" }
const _hoisted_21 = { class: "font-medium" }
const _hoisted_22 = { class: "font-medium" }
const _hoisted_23 = { class: "bg-white rounded-lg p-4" }
const _hoisted_24 = { class: "font-semibold text-gray-900 mb-3 flex items-center gap-2" }
const _hoisted_25 = { class: "bg-slate-900 text-white rounded-full p-1" }
const _hoisted_26 = { class: "grid grid-cols-2 md:grid-cols-4 gap-4" }
const _hoisted_27 = { class: "font-medium" }
const _hoisted_28 = { class: "font-medium" }
const _hoisted_29 = { class: "font-medium" }
const _hoisted_30 = { class: "font-medium" }
const _hoisted_31 = { class: "font-medium" }
const _hoisted_32 = { class: "font-medium" }
const _hoisted_33 = { class: "font-medium" }
const _hoisted_34 = {
  key: 0,
  class: "bg-white rounded-lg p-4"
}
const _hoisted_35 = { class: "font-medium" }
const _hoisted_36 = { class: "text-xs text-gray-500" }
const _hoisted_37 = { class: "bg-white rounded-lg p-2" }
const _hoisted_38 = { class: "border-b-gray-100 border-b-2" }
const _hoisted_39 = { class: "font-semibold text-gray-900 mb-3" }
const _hoisted_40 = { class: "flex items-center justify-between w-full" }
const _hoisted_41 = { class: "space-y-2" }
const _hoisted_42 = { class: "items-start" }
const _hoisted_43 = { class: "flex space-x-12 mb-2" }
const _hoisted_44 = { class: "font-medium" }
const _hoisted_45 = { class: "text-xs font-light text-gray-600" }
const _hoisted_46 = { class: "text-left" }
const _hoisted_47 = { class: "font-medium" }
const _hoisted_48 = { class: "flex items-center gap-4" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { class: "space-y-2" }
const _hoisted_51 = { class: "flex items-start justify-between" }
const _hoisted_52 = { class: "font-medium" }
const _hoisted_53 = { class: "text-sm text-gray-600" }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { class: "flex flex-wrap gap-2" }
const _hoisted_56 = { class: "grid grid-cols-2 gap-4 pt-2 border-t" }
const _hoisted_57 = { class: "text-sm font-medium" }
const _hoisted_58 = { class: "text-sm font-medium" }
const _hoisted_59 = { class: "flex items-center justify-end gap-3 p-2" }

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Badge } from '@/components/ui/badge';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle
} from '@/components/ui/card';
import {
  AlertCircle,
  CheckCircle2,
  ClipboardPlus,
  User,
  XCircle
} from 'lucide-vue-next';
import { ref } from 'vue';
import ReqRespPreviewSheet from './ReqRespPreviewSheet.vue';


interface Props {
  response: any[];
}



export default /*@__PURE__*/_defineComponent({
  __name: 'PreviewResultsTableView',
  props: {
    response: {}
  },
  setup(__props: any) {

const props = __props

const isSheetOpen = ref(false)

const jsonItem = ref(false)

const handleViewSuccessJson = (item: any) => {
  console.log(`Item: ${item}`);
  jsonItem.value  = item;
  isSheetOpen.value = true;

}

const handleViewRequest = (item: any) => {
  console.log(`Item: ${item}`);
  jsonItem.value  = item;
  isSheetOpen.value = true;

}

// Check if response contains error/failure
const isFailureResponse = (item: any) => {
  return item.status === 'FAILURE' || item.status_code >= 400
}

// Get status badge variant
const getStatusVariant = (status: string) => {
  switch (status?.toUpperCase()) {
    case 'SUCCESS':
      return 'default'
    case 'FAILURE':
      return 'destructive'
    case 'PENDING':
      return 'secondary'
    default:
      return 'outline'
  }
}

// Format date
const formatDate = (dateStr: string) => {
  if (!dateStr) return 'N/A'
  return new Date(dateStr.replace(/\//g, '-')).toLocaleDateString('en-ZA', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_CardFooter = _resolveComponent("CardFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Card), null, {
          default: _withCtx(() => [
            _createVNode(_unref(CardHeader), { class: "pb-2" }, {
              default: _withCtx(() => [
                _createVNode(_unref(CardDescription), null, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("Total Processed", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_unref(CardTitle), { class: "text-3xl" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.response.length), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(Card), null, {
          default: _withCtx(() => [
            _createVNode(_unref(CardHeader), { class: "pb-2" }, {
              default: _withCtx(() => [
                _createVNode(_unref(CardDescription), null, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("Successful", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_unref(CardTitle), { class: "text-3xl text-green-600" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.response.filter(r => !isFailureResponse(r)).length), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(Card), null, {
          default: _withCtx(() => [
            _createVNode(_unref(CardHeader), { class: "pb-2" }, {
              default: _withCtx(() => [
                _createVNode(_unref(CardDescription), null, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("Failed", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_unref(CardTitle), { class: "text-3xl text-red-600" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.response.filter(r => isFailureResponse(r)).length), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.response, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "space-y-4"
        }, [
          (isFailureResponse(item))
            ? (_openBlock(), _createBlock(_unref(Card), {
                key: 0,
                class: "border-red-200 bg-red-50"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(CardHeader), null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_unref(XCircle), { class: "h-6 w-6 text-red-600" }),
                          _createElementVNode("div", null, [
                            _createVNode(_unref(CardTitle), { class: "text-lg text-red-900" }, {
                              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                _createTextVNode("Rollover Failed", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_unref(CardDescription), { class: "text-red-700 mt-1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.description || 'An error occurred during rollover'), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ]),
                        _createVNode(_unref(Badge), {
                          variant: getStatusVariant(item.status)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.status) + " (" + _toDisplayString(item.status_code) + ") ", 1)
                          ]),
                          _: 2
                        }, 1032, ["variant"])
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(CardContent), null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _cache[10] || (_cache[10] = _createElementVNode("h4", { class: "font-semibold text-gray-900 mb-3" }, "Member Information", -1)),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", null, [
                            _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Scheme", -1)),
                            _createElementVNode("p", _hoisted_7, _toDisplayString(item.membership?.scheme_code || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Option", -1)),
                            _createElementVNode("p", _hoisted_8, _toDisplayString(item.membership?.option_code || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Membership Number", -1)),
                            _createElementVNode("p", _hoisted_9, _toDisplayString(item.membership?.membership_number || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Dependant", -1)),
                            _createElementVNode("p", _hoisted_10, _toDisplayString(item.membership?.dependant_code || 'N/A'), 1)
                          ])
                        ]),
                        (item.membership?.tariff_codes?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-xs text-gray-500 mb-2" }, "Attempted Tariff Codes", -1)),
                              _createElementVNode("div", _hoisted_12, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.membership.tariff_codes, (code) => {
                                  return (_openBlock(), _createBlock(_unref(Badge), {
                                    key: code,
                                    variant: "outline",
                                    class: "bg-red-50"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(code), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_CardFooter, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_Button, {
                              size: "lg",
                              onClick: ($event: any) => (handleViewRequest(item)),
                              class: "bg-[#cfb76f] border-none text-white py-1 px-3 rounded-md"
                            }, {
                              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                _createTextVNode(" VIEW JSON REQUEST ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"])
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            : (item.Transaction)
              ? (_openBlock(), _createBlock(_unref(Card), {
                  key: 1,
                  class: "border-green-200 bg-green-50 p-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CardHeader), null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_unref(CheckCircle2), { class: "h-6 w-6 text-green-600" }),
                            _createElementVNode("div", null, [
                              _createVNode(_unref(CardTitle), { class: "text-lg text-green-900" }, {
                                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                  _createTextVNode("Rollover Successful", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_unref(CardDescription), { class: "text-green-700 mt-1" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Transaction #" + _toDisplayString(item.Transaction.TransactionHeader.TranNum), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _createVNode(_unref(Badge), {
                            variant: "default",
                            class: "bg-green-600"
                          }, {
                            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                              _createTextVNode("SUCCESS", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(CardContent), { class: "space-y-4" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("h4", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _createVNode(_unref(ClipboardPlus), {
                                color: "white",
                                class: "h-4 w-4"
                              })
                            ]),
                            _cache[14] || (_cache[14] = _createTextVNode(" Transaction Details ", -1))
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", null, [
                              _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Transaction Number", -1)),
                              _createElementVNode("p", _hoisted_20, _toDisplayString(item.Transaction.TransactionHeader.TranNum), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Transaction Date", -1)),
                              _createElementVNode("p", _hoisted_21, _toDisplayString(item.Transaction.TransactionHeader.TranDate), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Destination", -1)),
                              _createElementVNode("p", _hoisted_22, _toDisplayString(item.Transaction.TransactionHeader.DestinationIdentifier), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("h4", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createVNode(_unref(User), { class: "w-4 h-4" })
                            ]),
                            _cache[18] || (_cache[18] = _createTextVNode(" Member Information ", -1))
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", null, [
                              _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Name", -1)),
                              _createElementVNode("p", _hoisted_27, _toDisplayString(item.Transaction.Authorisation.Firstnames) + " " + _toDisplayString(item.Transaction.Authorisation.Surname), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[20] || (_cache[20] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Membership", -1)),
                              _createElementVNode("p", _hoisted_28, _toDisplayString(item.Transaction.Authorisation.MembershipNumber), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[21] || (_cache[21] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Scheme", -1)),
                              _createElementVNode("p", _hoisted_29, _toDisplayString(item.Transaction.Authorisation.Scheme) + " - " + _toDisplayString(item.Transaction.Authorisation.OptionCode), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Birth Date", -1)),
                              _createElementVNode("p", _hoisted_30, _toDisplayString(formatDate(item.Transaction.Authorisation.BirthDate)), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[23] || (_cache[23] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Auth Seq", -1)),
                              _createElementVNode("p", _hoisted_31, _toDisplayString(item.Transaction.Authorisation.AuthSeq), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[24] || (_cache[24] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Program", -1)),
                              _createElementVNode("p", _hoisted_32, _toDisplayString(item.Transaction.Authorisation.Program), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[25] || (_cache[25] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Auth Start Date", -1)),
                              _createElementVNode("p", _hoisted_33, _toDisplayString(formatDate(item.Transaction.Authorisation.AuthorisationStartDate)), 1)
                            ])
                          ])
                        ]),
                        (item.Transaction.Authorisation.AuthorisationDisease?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              _cache[26] || (_cache[26] = _createElementVNode("h4", { class: "font-semibold text-gray-900 mb-3" }, "Disease Information", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Transaction.Authorisation.AuthorisationDisease, (disease) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: disease.ChronicDiseaseSeq,
                                  class: "flex items-center justify-between py-2 border-b last:border-b-0"
                                }, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("p", _hoisted_35, _toDisplayString(disease.ChronicDisease), 1),
                                    _createElementVNode("p", _hoisted_36, "Created: " + _toDisplayString(formatDate(disease.DateCreated)), 1)
                                  ]),
                                  _createVNode(_unref(Badge), {
                                    variant: disease.ActiveIndicator === 'Y' ? 'default' : 'secondary',
                                    class: "bg-slate-100 px-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(disease.ActiveIndicator === 'Y' ? 'Active' : 'Inactive'), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["variant"])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("h4", _hoisted_39, " Tariff Codes (" + _toDisplayString(item.Transaction.Authorisation.GroupDetails?.length || 0) + ") ", 1)
                          ]),
                          _createVNode(_unref(Accordion), {
                            type: "single",
                            collapsible: "",
                            class: "w-full"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Transaction.Authorisation.GroupDetails, (group, gIndex) => {
                                return (_openBlock(), _createBlock(_unref(AccordionItem), {
                                  key: gIndex,
                                  value: `group-${gIndex}`
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(AccordionTrigger), { class: "hover:no-underline" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_40, [
                                          _createElementVNode("div", _hoisted_41, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.ChargeDetails, (charge) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: charge.ChargeableCode,
                                                class: "p-3 rounded"
                                              }, [
                                                _createElementVNode("div", _hoisted_42, [
                                                  _createElementVNode("div", _hoisted_43, [
                                                    _createElementVNode("p", _hoisted_44, _toDisplayString(charge.ChargeableCode), 1),
                                                    _createVNode(_unref(Badge), { variant: "outline" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(group.GroupStartDate) + " " + _toDisplayString(group.GroupEndDate ? ` → ${group.GroupEndDate}` : ' → Ongoing'), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _createElementVNode("div", null, [
                                                    _createElementVNode("p", _hoisted_45, _toDisplayString(charge.Description), 1)
                                                  ])
                                                ])
                                              ]))
                                            }), 128))
                                          ]),
                                          _createElementVNode("div", _hoisted_46, [
                                            _createElementVNode("p", _hoisted_47, _toDisplayString(group.GroupTypeDescription), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_48, [
                                            _createVNode(_unref(Badge), { variant: "outline" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(group.UsedQuantity) + "/" + _toDisplayString(group.AllowedQuantity), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_unref(Badge), {
                                              variant: group.LineStatus === 'ACTIVE' ? 'default' : 'secondary'
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(group.LineStatus), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["variant"])
                                          ])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_unref(AccordionContent), { class: "space-y-4 pt-4" }, {
                                      default: _withCtx(() => [
                                        (group.ChargeDetails?.length)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                              _cache[27] || (_cache[27] = _createElementVNode("p", { class: "text-sm font-semibold mb-2" }, "Charge Details", -1)),
                                              _createElementVNode("div", _hoisted_50, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.ChargeDetails, (charge) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: charge.ChargeableCode,
                                                    class: "bg-gray-50 p-3 rounded"
                                                  }, [
                                                    _createElementVNode("div", _hoisted_51, [
                                                      _createElementVNode("div", null, [
                                                        _createElementVNode("p", _hoisted_52, _toDisplayString(charge.ChargeableCode), 1),
                                                        _createElementVNode("p", _hoisted_53, _toDisplayString(charge.Description), 1)
                                                      ]),
                                                      _createVNode(_unref(Badge), { variant: "outline" }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(charge.Publication), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ])
                                                  ]))
                                                }), 128))
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (group.SpecialityDetails?.length)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                              _cache[28] || (_cache[28] = _createElementVNode("p", { class: "text-sm font-semibold mb-2" }, "Specialities", -1)),
                                              _createElementVNode("div", _hoisted_55, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.SpecialityDetails, (spec) => {
                                                  return (_openBlock(), _createBlock(_unref(Badge), {
                                                    key: spec.Speciality,
                                                    variant: "secondary"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(spec.Speciality), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                                }), 128))
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_56, [
                                          _createElementVNode("div", null, [
                                            _cache[29] || (_cache[29] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Chronic Disease Seq", -1)),
                                            _createElementVNode("p", _hoisted_57, _toDisplayString(group.ChronicDiseaseSeq), 1)
                                          ]),
                                          _createElementVNode("div", null, [
                                            _cache[30] || (_cache[30] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Group Type Seq", -1)),
                                            _createElementVNode("p", _hoisted_58, _toDisplayString(group.GroupTypeSeq), 1)
                                          ])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CardFooter, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_59, [
                          _createVNode(_component_Button, {
                            size: "lg",
                            onClick: ($event: any) => (handleViewSuccessJson(item)),
                            class: "bg-[#cfb76f] border-none text-white py-1 px-3 rounded-md"
                          }, {
                            default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                              _createTextVNode(" VIEW JSON PAYLOAD ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
        ]))
      }), 128)),
      (!__props.response || __props.response.length === 0)
        ? (_openBlock(), _createBlock(_unref(Card), { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_unref(CardContent), { class: "flex flex-col items-center justify-center py-12" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AlertCircle), { class: "h-12 w-12 text-gray-400 mb-4" }),
                  _cache[32] || (_cache[32] = _createElementVNode("p", { class: "text-gray-500" }, "No results to display", -1))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", null, [
        (jsonItem.value && isSheetOpen.value)
          ? (_openBlock(), _createBlock(ReqRespPreviewSheet, {
              key: 0,
              open: isSheetOpen.value,
              "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((isSheetOpen).value = $event)),
              data: jsonItem.value
            }, null, 8, ["open", "data"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})